wbApp.controller('FormsCtrl', ['$scope', '$modal', '$window', 'formSvc', 'securitySvc', 'notificationSvc',
function ($scope, $modal, $window, formSvc, securitySvc, notificationSvc) {

    $scope.formsAreLoading = true;
    $scope.forms = [];

    formSvc.getAllActive().then(function (forms) {
        $scope.forms = _.orderBy(forms, ['name'], ['asc'])
        $scope.formsAreLoading = false;
    }, function (error) {
        $scope.formsAreLoading = false;
    });

    $scope.onFormClick = function (form) {
        // href="/Forms/FormsResponse?formId={{form.id}}"

        if (form.accessPermissions == 0) {
            if (!securitySvc.isAuthenticated()) {
                notificationSvc.advertiseLogin();
                return;
            }
        }

        $window.location.href = $window.location.origin + '/Forms/FormsResponse?formId=' + form.id;
    }

    $scope.tabs = [
    {
        title: 'TXT_TITLE_FORMS',
        template: 'forms/forms-tab.html'
    }];

    $scope.tabs.activeTab = 0;

}]);